<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Antrian Mobile</h5>
            </template>
            <div class="form-content-wrapper mb-4">  
                <h6 class="form-title">Pencarian Nomor Referensi</h6>
                <div class="d-flex form-content-wrapper mb-4">
                    <b-form-group class="mr-2 mb-0">
                        <b-form-input ref="inputNoRef"
                            v-model="input.noRef" :disabled="isBusy" v-on:keyup.enter="getItems()" name="filterTable"
                            id="filterInput"
                            placeholder="No. Referensi"
                        ></b-form-input>
                    </b-form-group>
                    <b-button variant="pgiBtn" name="searchTableBtn" @click="getItems()"> 
                        <b-spinner small class="loading-spinner" v-if="isBusy"></b-spinner>
                        <i class="fa fa-search" v-else></i>
                    </b-button>
                </div>
                <div class="detail-data-wrapper mb-4" v-if="showTable == true">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="items" 
                        :fields="fields" 
                        responsive class="mb-3"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Mengambil data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data antrian dengan nomor referensi ini.
                        </template>
                        <template v-slot:cell(barang)="row">
                            <p class="mb-0">{{ row.item.jenis }}</p>
                            <p class="mb-0 smallText text-muted">{{ row.item.merk }} - {{ row.item.tipe }}</p>
                            <p class="mb-0 smallText text-muted">{{ row.item.warna }} {{ row.item.tahun != null ? `- Tahun ${row.item.tahun}` : "" }}</p>
                        </template>
                        <template v-slot:cell(action)="row">
                            <div class="no-wrap">
                                <b-button size="sm" variant="pgiBtn" name="bayarBtn" @click="processAntrian(row.item)">
                                    Proses
                                </b-button>
                            </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="show" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'antrian-mobile',
    data() {
        return {

            isBusy: false,
            isSubmitting: false,
            showTable: false,
            show: 1,

            input: {
                noRef: "",
            },

            options: [
                { value: 1, text: '10'},
                { value: 2, text: '20'},
                { value: 3, text: '30'},
                { value: 4, text: '40'},
                { value: 5, text: '50'},
            ],

            fields: [
                { key: "noReferensi", label: "No. Referensi" },
                { key: "nasabah", label: "Nasabah" },
                { key: "barang", label: "Barang" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: ""

        }
    }, 

    methods: {

        getItems(page = 1) {

            if(this.$helper.isNullOrEmpty(this.input.noRef)) {
                return this.$helper.toastErr(this, "Mohon mengisi nomor referensi!")
            }

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            return this.$axios.get("gadai-mobile/search/" + this.input.noRef + "/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total
                this.showTable = true

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        processAntrian(item) {

            if(item.jenisPinjaman == 1) {
                this.$router.push({ path: "/gadai/elektronik?ref=" + item.noReferensi })
            }
            else if(item.jenisPinjaman == 2) {
                this.$router.push({ path: "/gadai/kendaraan?ref=" + item.noReferensi })
            }
            else {
                this.$helper.toastErr(this, "Data antrian tidak dapat dibaca, silahkan membuat gadai manual melalui menu Gadai > Elektronik / Kendaraan!")
            }

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

    },

    mounted(){
        this.$refs.inputNoRef.focus()
    }

}
</script>
